import React from 'react'
import { Box, Button, IconButton, Typography } from '@material-ui/core'
import {
  ArrowLeft as ArrowLeftIcon,
  ExternalLink as ExternalLinkIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from 'react-feather'

import useStyles from './styles'

const EmailFooter = ({
  onBack,
  onSendTest,
  currentPage,
  totalPages,
  onNext,
  onPrev,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.footer}>
      <Box className={classes.footerRight}>
        <Button
          variant="outlined"
          startIcon={<ArrowLeftIcon size={16} />}
          onClick={onBack}
          className={classes.footerBtnBack}
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          color="primary"
          endIcon={<ExternalLinkIcon size={14} />}
          onClick={onSendTest}
          className={classes.footerBtnSendTest}
        >
          Enviar Email Teste
        </Button>

        <Box className={classes.footerPagination}>
          <IconButton
            size="small"
            disabled={currentPage <= 1}
            onClick={onPrev}
            className={classes.footerPaginationArrow}
          >
            <ChevronLeftIcon size={16} />
          </IconButton>
          <Typography className={classes.footerPaginationLabel}>
            Página {currentPage} de {totalPages}
          </Typography>
          <IconButton
            size="small"
            disabled={currentPage >= totalPages}
            onClick={onNext}
            className={classes.footerPaginationArrow}
          >
            <ChevronRightIcon size={16} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  )
}

export default EmailFooter
